import { gate } from 'hub-http/gates';
export const ENTERPRISE_MANAGED_AUTH_GATE = gate('Developers:AdminGovernance:EMA');